const ROUTES = {
    base: '/',
    product: '/products',
    company: '/company',
    features: '/features',
    pricing: '/pricing',
    location: '/locations',
    contacts: '/contacts',
    blog: '/blog',
    about_us: '/about-us',
    faq: '/faq',
    terms_and_conditions: '/terms-and-conditions',
    privacy_policy: '/privacy-policy',
    refund_policy: '/refund-policy',
    landing_page: '/landing-page',
    brand_assets: '/brand-assets',
    ui_kit: '/ui-kit',
    update_sitemap: '/update-sitemap',
};
export default ROUTES;
